export const images = {
  rooftop: 'https://cdn.magicpatterns.com/patterns/generated-images/665a31c2-b585-47a8-a81a-819b606e13a4.jpg',
  barn: 'https://cdn.magicpatterns.com/patterns/generated-images/8af60e7d-af4e-4644-9648-94648ff1e87b.jpg',
  festival: 'https://cdn.magicpatterns.com/patterns/generated-images/7d451328-877d-4097-95ce-0024de3c36f8.jpg',
  jazzClub: 'https://cdn.magicpatterns.com/patterns/generated-images/8d415991-db2a-4e55-a629-09136f227ed2.jpg',
  gala: 'https://cdn.magicpatterns.com/patterns/generated-images/11fe3594-4bb9-4571-8e59-aaff5f62a355.jpg',
  blockParty: 'https://cdn.magicpatterns.com/patterns/generated-images/851448b3-52b5-49d9-9c5c-0a2ce3dc5dc4.jpg',
  beach: 'https://cdn.magicpatterns.com/patterns/generated-images/cf22df50-8c71-40cd-9158-9c22e5880c0c.jpg',
  nye: 'https://cdn.magicpatterns.com/patterns/generated-images/76670609-04db-434d-9553-a28f3616af96.jpg',
  ploy: 'https://cdn.magicpatterns.com/patterns/generated-images/58bd2d7f-cc68-4cde-8f2f-50a49c39c125.jpg',
  indieBand: 'https://cdn.magicpatterns.com/patterns/generated-images/0a46b0ed-b7c5-4841-8698-fa7edf0829ee.jpg',
  jazzTrio: 'https://cdn.magicpatterns.com/patterns/generated-images/9cd8942f-547f-4314-bb7b-e641111aa4d8.jpg',
  acoustic: 'https://cdn.magicpatterns.com/patterns/generated-images/92e06aaa-df67-4be3-a8ed-7595798eab81.jpg',
  funkBand: 'https://cdn.magicpatterns.com/patterns/generated-images/e7c61c5c-119e-492f-bacb-6f3e43ef2bce.jpg',
  popDuo: 'https://cdn.magicpatterns.com/patterns/generated-images/41058094-412a-4b8b-aee2-0591c4952870.jpg',
  rnbSinger: 'https://cdn.magicpatterns.com/patterns/generated-images/0d4f2a5e-9dce-40bb-94df-84ffced99d58.jpg',
  folkDuo: 'https://cdn.magicpatterns.com/patterns/generated-images/a04e0f9c-91de-4cf4-a072-88c2d8852a55.jpg',
};

export const eventPhotoLibrary = [
  images.rooftop,
  images.barn,
  images.festival,
  images.jazzClub,
  images.gala,
  images.blockParty,
  images.beach,
  images.nye,
];

export const performerPhotoLibrary = [
  images.ploy,
  images.jazzClub,
  images.rnbSinger,
  images.rooftop,
  images.acoustic,
  images.blockParty,
];
